const getDetailsLink = (
    searchIdentifier?: string,
    listingUris?: { detail?: string | null } | null
) => {
    const searchIdentifierQueryString = searchIdentifier
        ? `?search_identifier=${searchIdentifier}`
        : '';

    return listingUris?.detail
        ? `${listingUris?.detail}${searchIdentifierQueryString}`
        : '#';
};

export default getDetailsLink;
